module.exports = __webpack_public_path__ + "img/inpay.bf0517c2.png";